/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="19.01"
        viewBox="0 0 19 19.01"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.79 16.21a2.59 2.59 0 0 0 2.55 2.8 2.44 2.44 0 0 0 1.71-.7 4.1 4.1 0 0 0 1.07-2.95A3.47 3.47 0 0 0 7.9 14l6.11-6.09a3.34 3.34 0 0 0 1.32.2 4.07 4.07 0 0 0 3-1.09 2.46 2.46 0 0 0 .7-1.72A5.94 5.94 0 0 1 15.51.78 2.48 2.48 0 0 0 11.98.7a3.84 3.84 0 0 0-1.07 2.86 4 4 0 0 0 .22 1.45L5.01 11.1a4.42 4.42 0 0 0-4.28.9 2.4 2.4 0 0 0-.7 1.7 2.47 2.47 0 0 0 .77 1.79 2.57 2.57 0 0 0 2 .72ZM1.41 12.7a2.93 2.93 0 0 1 2.18-.82 3 3 0 0 1 1.35.26l.3.1 6.94-6.9.07-.07-.11-.3a3.45 3.45 0 0 1-.26-1.38 2.89 2.89 0 0 1 .77-2.19 1.5 1.5 0 0 1 1.08-.4 1.47 1.47 0 0 1 1 .49 1.62 1.62 0 0 1 .42 1.42 1 1 0 0 0 .13.69.84.84 0 0 0 .8.22 1.67 1.67 0 0 1 1.4.4 1.52 1.52 0 0 1 .48 1.08 1.45 1.45 0 0 1-.41 1 3.22 3.22 0 0 1-2.31.8 2.71 2.71 0 0 1-1.23-.24l-.3-.11-7 7 .1.3a3 3 0 0 1 .28 1.29 3.08 3.08 0 0 1-.78 2.28 1.49 1.49 0 0 1-2.12-.12 1.69 1.69 0 0 1-.42-1.46.82.82 0 0 0-.16-.69.65.65 0 0 0-.48-.17h-.22a1.69 1.69 0 0 1-1.47-.42 1.48 1.48 0 0 1-.47-1.08 1.45 1.45 0 0 1 .44-.98Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BoneIcon';

export default Icon;
